'use client';

import { usePreferences } from '@/components/providers/preferences-provider';
import { formatPace } from '@/utils/number-format';
import { convertDistance } from '@turf/turf';

interface PaceProps {
  paceInSeconds: number;
  originalUnit?: 'miles' | 'kilometers';
}

export function Pace({ paceInSeconds, originalUnit = 'miles' }: PaceProps) {
  const { unit } = usePreferences();
  const convertedSeconds =
    paceInSeconds /
    convertDistance(1, originalUnit, unit === 'mile' ? 'miles' : 'kilometers');
  const pace = formatPace(convertedSeconds);
  const unitNiceName = unit === 'mile' ? 'mi' : 'km';
  return (
    <div className="tabular-nums">
      <span>{pace}</span>
      <span>/</span>
      <span>{unitNiceName}</span>
    </div>
  );
}
